<mat-toolbar color="primary" class="toolbar">
    <app-back-button [route]="['/home', 'perfil']" color="secondary"></app-back-button>
    <div>{{ "CONTACT_US.TITLE" | translate }}</div>
</mat-toolbar>

<mat-card class="mat-elevation-z0">
    <mat-card-content>
        <p>{{ "CONTACT_US.SUBTITLE" | translate }}</p>

        <form [formGroup]="formGroup">
            <mat-form-field>
                <mat-label>{{ "CONTACT_US.INPUTS.SUBJECT" | translate }}</mat-label>
                <input
                    [id]="'input_profile-contact-us_Topic'"
                    matInput
                    #subject
                    maxlength="50"
                    formControlName="subject"
                    required
                />
                <mat-hint align="end"> {{ subject.value.length }} / 50 </mat-hint>
                <mat-error>{{ "MESSAGES.REQUIRED" | translate }}</mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{ "CONTACT_US.INPUTS.MESSAGE" | translate }}</mat-label>
                <textarea
                    matInput
                    #message
                    placeholder="{{ 'CONTACT_US.INPUTS.MESSAGE_PLACEHOLDER' | translate }}"
                    maxlength="500"
                    formControlName="message"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="10"
                    cdkAutosizeMaxRows="15"
                ></textarea>
                <mat-hint align="end"> {{ message.value.length }} / 500 </mat-hint>
            </mat-form-field>
        </form>
        <button [id]="'button_profile-contact-us_ContateNos'" mat-raised-button color="primary" (click)="send()">
            {{ "CONTACT_US.ACTIONS.SEND" | translate }}
        </button>
    </mat-card-content>
</mat-card>
